import { RefObject, useCallback, useEffect, useRef } from 'react';

/** Assign the returned ref object to the element on which you want to cancel the default wheel action
 */
function usePreventDefaultWheelEvent<T extends HTMLElement>(): RefObject<T> {
  const ref = useRef<T>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.addEventListener('wheel', handleWheel, {
        passive: false,
      });
    }
    return () => {
      if (ref.current) {
        ref.current.removeEventListener('wheel', handleWheel);
      }
    };
  }, []);

  const handleWheel = useCallback((e: MouseEvent) => {
    e.preventDefault();
  }, []);

  return ref;
}

export default usePreventDefaultWheelEvent;
